import Cookies from './Cookies';

export default class SubNav {
  constructor(rootElement) {
    this.rootElement = rootElement;
    this.footer = document.querySelector('footer');
    this.body = document.querySelector('body');
    this.toggleButtons = this.rootElement.querySelectorAll('.js-toggle');
    this.panes = this.rootElement.querySelectorAll('.js-pane');
    this.cookies = new Cookies();
    this.alert_banner = this.rootElement.querySelector('.js-subnav-alert-banner');
    this.notification_dot = this.rootElement.querySelector('.js-subnav-notification-dot');
    this.notification_banner = this.rootElement.querySelector('.js-subnav-notification-banner');
    this.notification_banner_close = this.rootElement.querySelector('.js-subnav-close-notification-banner');
    this.notification_banner_text = this.rootElement.querySelector('.js-subnav-notification-banner-text');
    this.help_text = this.rootElement.querySelector('.js-subnav-help-text');

    for (let toggleButton of this.toggleButtons) {
      toggleButton.addEventListener('click', (event) => this.toggle(event));
    }

    if(this.alert_banner && this.cookies.getCookie('js-alert-banner-seen') != 'true' ) {
      this.alert_banner.classList.remove('--alert-hidden');
    }

    //auto-close the newsletter banner if the user scrolls at least 75% of the page
    window.addEventListener("scroll", () => {
      if(this.alert_banner && this.getPercentScrolled() >= 35) {
        this.alert_banner.classList.add('--alert-hidden');
        this.cookies.setCookie('js-alert-banner-seen', 'true', 365);
      }

      if(this.getPercentScrolled() >= 75 && this.cookies.getCookie('js-newsletter-banner-closed') != 'true' && this.cookies.getCookie('js-second-pageload') === 'true'){
        this.openPane('newsletter');
        if(this.notification_dot && this.cookies.getCookie('js-notification-dot-opened') != 'true') {
          this.notification_dot.classList.add('--hidden');
          this.show_dot_on_close = true;
        }
      }
    }, false);


    if(this.cookies.getCookie('js-first-pageload') === 'true') {
      this.cookies.setCookie('js-second-pageload', 'true', 365);
    }

    this.cookies.setCookie('js-first-pageload', 'true', 365);



    /*
      If the user clicks outside the subnav when it is open, close the subnav.
      The two event listeners below achieve this.
    */
    document.addEventListener('click', (event) => {
      if(event.target.tagName != 'INPUT') {
        this.closeAllPanes();
      }

      //reset footer z-index
      this.footer.style.zIndex = 'unset';
    });

    this.rootElement.addEventListener('click', (event) => {
      if(event.target.tagName != 'INPUT') {
        event.stopPropagation();
      }
    });

    if(this.notification_banner && this.notification_banner_close && this.notification_banner_text) {
      if(this.body.classList.contains('single-road-trips') && this.cookies.getCookie('js-notification-banner-used') != 'true') {
        setTimeout(() => {
          this.notification_banner.classList.remove('--hidden');
        }, 2000);
      }
      this.notification_banner_text.addEventListener('click', () => {
        this.openPane('subnav');
        this.notification_banner.classList.add('--hidden');
        this.cookies.setCookie('js-notification-banner-used', 'true', 365);

        if(this.help_text) {
          setTimeout(() => {
            this.help_text.classList.add('--hidden');
          }, 2000);
        }
      });

      this.notification_banner_close.addEventListener('click', () => {
        this.notification_banner.classList.add('--hidden');
        this.cookies.setCookie('js-notification-banner-used', 'true', 365);
      });
    }
  }

  toggle(event) {
    const buttonClicked = event.target;
    const paneId = buttonClicked.dataset.paneId;

    // Let's find the corresponding pane.
    const panesArray = [...this.panes];
    const matchingPanes = panesArray.filter(pane => pane.dataset.paneId == paneId);

    if (matchingPanes.length == 1) {
      let pane = matchingPanes[0];

      if (pane.classList.contains('--open')) {
        pane.classList.remove('--open');
        buttonClicked.classList.remove('--enabled');

        for (let toggleButton of this.toggleButtons) {
          toggleButton.classList.remove('--hidden');
        }

        //set cookie only for newsletter when closed
        if(pane.dataset.paneId == 'newsletter') {
          this.cookies.setCookie('js-newsletter-banner-closed', 'true', 30);
        }

        if(this.show_dot_on_close == true) {
          this.notification_dot.classList.remove('--hidden');
        }

        //reset footer z-index
        this.footer.style.zIndex = 'unset';
      } else {
        //bump footer z-index
        // this.footer.style.zIndex = '100';

        this.closeAllPanes();
        pane.classList.add('--open');
        buttonClicked.classList.add('--enabled');

        // Hide all other buttons except for this one
        const buttonsArray = [...this.toggleButtons];
        const matchingButtons = buttonsArray.filter(button => button != buttonClicked);
        for (let button of matchingButtons) {
          button.classList.add('--hidden');
        }

        //set cookie only for road trips notification dot/banner when opened
        if(this.notification_dot && pane.dataset.paneId == 'subnav') {
          this.cookies.setCookie('js-notification-dot-opened', 'true', 365);
          this.notification_dot.classList.add('--hidden');
          this.show_dot_on_close = false;

          if(this.help_text) {
            setTimeout(() => {
              this.help_text.classList.add('--hidden');
            }, 2000);
          }
        } else if(this.notification_dot && this.cookies.getCookie('js-notification-dot-opened') != 'true') {
          this.notification_dot.classList.add('--hidden');
          this.show_dot_on_close = true;
        }

        if(this.notification_banner) {
          this.cookies.setCookie('js-notification-banner-used', 'true', 365);
          this.notification_banner.classList.add('--hidden');

          if(this.help_text) {
            setTimeout(() => {
              this.help_text.classList.add('--hidden');
            }, 2000);
          }
        }
      }
    }
  }

  openPane(pane_name) {
    this.closeAllPanes();
    document.querySelector('.js-pane[data-pane-id="' + pane_name + '"]').classList.add('--open');
    document.querySelector('.js-toggle[data-pane-id="' + pane_name + '"]').classList.add('--enabled');

    // Hide all other buttons except for this one
    const buttonsArray = [...this.toggleButtons];
    const matchingButtons = buttonsArray.filter(button => button != document.querySelector('.js-toggle[data-pane-id="' + pane_name + '"]'));
    for (let button of matchingButtons) {
      button.classList.add('--hidden');
    }
  }

  closeAllPanes() {
    for (let pane of this.panes) {
      pane.classList.remove('--open');
    }

    for (let toggleButton of this.toggleButtons) {
      toggleButton.classList.remove('--enabled');
      toggleButton.classList.remove('--hidden');
    }
  }

  getPercentScrolled() {
    var winheight = window.innerHeight || (document.documentElement || document.body).clientHeight
    var docheight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );
    var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
    var trackLength = docheight - winheight
    var pctScrolled = Math.floor(scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)

    return pctScrolled
  }
}
